export default __webpack_public_path__ + "static/media/deal-3.6a97e4e7.webp";